import type { Audio, ThemesPicture } from '@/@types/common'
import type { CDNFile } from '@/utils/upload'
import { z } from 'zod'

export enum AttachmentStatus {
	WAIT_TO_UPLOAD = 'WAIT_TO_UPLOAD',
	UPLOADING = 'UPLOADING',
	UPLOADED = 'UPLOADED',
	UPLOAD_FAILED = 'UPLOAD_FAILED',
}

export enum AttachmentType {
	PICTURE = 'PICTURE',
	VIDEO = 'VIDEO',
	LINK = 'LINK',
}

export const LinkInfoSchema = z.object({
	link: z.string(),
	linkUrl: z.string().url(),
	pictureUrl: z.string().url(),
	title: z.string(),
	type: z.string(),
	brandLogoImage: z.custom<ThemesPicture>().optional(),
	audio: z.custom<Audio>().optional(),
	abstract: z.string().optional(),
})

export type LinkInfo = z.infer<typeof LinkInfoSchema>

export interface IAttachment {
	id: string
}

export interface FileAttachment extends IAttachment {
	type: AttachmentType.PICTURE | AttachmentType.VIDEO
	file?: File
	cdn?: {
		file: CDNFile
	}
	status: AttachmentStatus
	metadata?: {
		width: number
		height: number
	}
}

export interface UploadableFileAttachment extends FileAttachment {
	file: File
}

export interface LinkAttachment extends IAttachment {
	type: AttachmentType.LINK
	linkInfo: LinkInfo
}

export type Attachment = FileAttachment | LinkAttachment
